import React, {useContext, useEffect, useState} from "react";
import {Route, Switch} from "react-router-dom";
import NewObject from "../../../overbox/sheet/product/NewObject";
import ObjectSheet from "../../../sheet/ObjectSheet";
import Listing from "../../../table/Listing";
import usePrevious from "../../../../class/tool/usePrevious";
import ExportCatalog from "./ExportCatalog";
import FilterPopup from "../../../table/FilterPopup";
import CatalogController from "../../../../stories/_catalog/Catalogs/CatalogController";
import CategoryController from "../../../../stories/_catalog/Categories/CategoryController";
import ProductController from "../../../../stories/_catalog/Products/ProductController";
import PricelistController from "../../../../stories/_catalog/Pricelists/PricelistController";
import VatRateController from "../../../../stories/_catalog/VatRates/VatRateController";
import TagController from "../../../../stories/_tag/TagController";
import ListingContext from "../../../../context/ListingContext";
import BackofficeContext from "../../../../context/BackofficeContext";
import "../../../../css/page/content/product/Product.css";

const Products = () => {
    const item = "products";
    const itemClass = "product";
    const titleWindow = "Produits";
    const placeholderSearch = "un produit";
    const titleNbItems = "produits";
    const emptyList = "Aucun produit";
    const textRemoveButton = "ce produit";
    const activeHistory = false;
    const env = JSON.parse(localStorage.getItem("env"));
    const settings = JSON.parse(localStorage.getItem("storeSettings"));
    const company = JSON.parse(localStorage.getItem("company"));
    const defaultCatalog = JSON.parse(localStorage.getItem("catalog"));
    const { setEvent } = useContext(BackofficeContext);
    const [ pageSelect, setPageSelect ] = useState(1);
    const [ loading, setLoading ] = useState(true);
    const [ categories, setCategories ] = useState([
        {
            name: "Toutes les catégories",
            id: -1,
            type: ""
        }
    ]);
    const [ model, setModel ] = useState([]);
    const [ list, setList ] = useState([]);
    const [ options, setOptions ] = useState([]);
    const [ secondaryOptions, setSecondaryOptions ] = useState([]);
    const [ pagination, setPagination ] = useState(null);
    const [ perPage, setPerPage ] = useState(25);
    const [ sortingName, setSortingName ] = useState("updated_at");
    const [ sortingValue, setSortingValue ] = useState("desc");
    const [ catalogId, setCatalogId ] = useState(Object.keys(defaultCatalog).length > 0 ? defaultCatalog.id : null);
    const [ storeId, setStoreId ] = useState(null);
    const [ pricelistId, setPricelistId ] = useState(null);
    const [ tags, setTags ] = useState([]);
    const [ stores, setStores ] = useState([]);
    const [ catalogs, setCatalogs ] = useState([]);
    const [ pricelists, setPricelists ] = useState([]);
    const [ vatRates, setVatRates ] = useState([]);
    const [ exportForm, setExportForm ] = useState(false);
    const [ filters, setFilters ] = useState({});
    const [ filterValues, setFilterValues ] = useState({});
    const [ contextValues, setContextValues ] = useState({});
    const [ showFilters, setShowFilters ] = useState(false);
    const prevPageSelect = usePrevious(pageSelect);
    const prevPerPage = usePrevious(perPage);
    const prevCatalogId = usePrevious(catalogId);

    const initStores = () => {
        if (env.type === "store")
            return

        let storesTmp = [
            {
                name: "Toutes les boutiques",
                id: null
            }
        ]

        for (let i in env.stores) {
            storesTmp.push({
                name: env.stores[i].name,
                id: env.stores[i].id,
                object: env.stores[i]
            })
        }

        setStores(storesTmp)
    }
    const updateModel = () => {
        const catalogs = JSON.parse(localStorage.getItem("catalogs"))
        let modelsTmp = [
            {
                "class": "name",
                "sortingParam": "name",
                "title": "Nom",
                "attributes": ["name"],
                "type": "text"
            },
            {
                "class": "price",
                "sortingParam": null,
                "title": "Prix",
                "attributes": ["price"],
                "type": "price"
            },
            {
                "class": "vat",
                "sortingParam": null,
                "title": "TVA",
                "attributes": ["vat"],
                "type": "vat"
            },
            {
                "class": "reference",
                "sortingParam": "reference",
                "title": "Référence",
                "attributes": ["reference"],
                "type": "text"
            }
        ]
        let placeCategories = 1;
        let placeSubCategories = 1;

        if (catalogs.length > 1 && catalogId === null) {
            modelsTmp.splice(1, 0, {
                "class": "catalogName",
                "sortingParam": null,
                "title": "Catalogue",
                "attributes": ["catalog_name"],
                "type": "catalogName"
            })
        }

        placeCategories = modelsTmp.findIndex(_ => _.type === "catalogName") > 0 ? 2 : 1;
        placeSubCategories = placeCategories + 1;

        modelsTmp.splice(placeCategories, 0, {
            "class": "category",
            "sortingParam": null,
            "title": "Catégorie",
            "attributes": ["category_name"],
            "type": "text"
        });

        if (categories.find(_ => _.type === "subcategory") !== undefined) {
            modelsTmp.splice(placeSubCategories, 0, {
                "class": "category",
                "sortingParam": null,
                "title": "Sous-categorie",
                "attributes": ["subcategory_name"],
                "type": "text"
            });
        }

        setModel(modelsTmp)
    }
    const initOptions = () => {
        let optionsTmp = []
        let secondaryOtionsTmp = []

        if (settings === null || company.socialReason === null || (company.socialReason !== null && settings.allowedProductCreation === 1)) {
            optionsTmp.push({
                "class": "blue export",
                "title": "Exporter",
                "action": exportCatalog,
                "link": null
            });
            optionsTmp.push({
                "class": "add moreActions",
                "title": "Créer " + placeholderSearch,
                "action": "",
                "link": "/" + item + "/new"
            });

            secondaryOtionsTmp.push({
                "class": "blue addMany",
                "title": "Ajouter plusieurs " + titleNbItems,
                "action": "handleAddMany",
                "link": ""
            });
            secondaryOtionsTmp.push({
                "class": "gray import",
                "title": "Importer",
                "action": "handleImport",
                "link": ""
            });
        }

        setOptions(optionsTmp)
        setSecondaryOptions(secondaryOtionsTmp)
    }
    const initFilters = () => {
        setFilterValues(prev => ({
            ...prev,
            store_id: null,
            catalog_id: catalogId,
            category_id: null,
            category_type: null,
            vat_rate_id: null,
            price_list_id: null,
            tags: [],
            inputs: [],
            input: null,
            variablePrice: null
        }));
    }
    const getProducts = (pPage = 1, pPerPage = 25, pSortingName = "", pSortingValue = "") => {
        let controller;
        let paramPage = pPage !== 1 ? pPage : pageSelect;
        let paramPerPage = pPerPage !== 25 ? pPerPage : perPage;
        let paramSortingName = pSortingName !== "" ? pSortingName : sortingName;
        let paramSortingValue = pSortingValue !== "" ? pSortingValue : sortingValue;

        setLoading(true);

        controller = new ProductController();
        controller._callback = handleGetProducts;
        controller.index(filterValues, paramPage, paramPerPage, paramSortingName, paramSortingValue, false, pricelistId);
    }
    const handleGetProducts = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                setList(list);
                setPagination(pagination !== undefined ? pagination : null );
                break;
            default:
                setEvent({
                    type: "error",
                    text: "Une erreur s'est produite lors de la récupération des produits"
                });
                break;
        }

        setLoading(false);
    }
    const getCatalogs = () => {
        const controller = new CatalogController()
        controller._callback = handleGetCatalogs
        controller.index(null, 0, 0, "name", "asc", true);
    }
    const handleGetCatalogs = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                localStorage.setItem("catalogs", JSON.stringify(list))

                if (list.length === 1)
                    localStorage.setItem("catalog", JSON.stringify(list[0]))
                else
                    localStorage.setItem("catalog", JSON.stringify({}))

                let listTmp = [];

                for (let i in list) {
                    listTmp.push({
                        name: list[i].name,
                        id: list[i].id,
                        object: list[i]
                    })
                }

                if (list.length > 0) {
                    setFilterValues(prev => ({
                        ...prev,
                        catalog_id: list[0].id
                    }));
                }

                setCatalogs(listTmp);

                break
            default: break
        }
    }
    const getCategories = () => {
        if (catalogId !== null) {
            const controller = new CategoryController();
            controller._callback = handleGetCategories;
            controller.index(filterValues, 0, 0, "name", "asc", true);
        }
        else {
            setCategories([
                {
                    name: "Toutes les catégories",
                    id: -1,
                    type: ""
                }
            ])
        }
    }
    const handleGetCategories = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                let categoriesTmp = [
                    {
                        name: "Toutes les catégories",
                        id: -1,
                        type: ""
                    }
                ];
                let i, j;

                for (i in list) {
                    categoriesTmp.push({
                        name: list[i].name,
                        id: list[i].id,
                        type: "category"
                    });

                    for (j in list[i].subCategories)
                        categoriesTmp.push({
                            name: "--- " + list[i].subCategories[j].name,
                            id: list[i].subCategories[j].id,
                            type: "subcategory"
                        });
                }

                setCategories(categoriesTmp);
                break;
            default:
                console.log(error);
                break;
        }
    }
    const getPricelists = () => {
        if (catalogId !== null) {
            const controller = new PricelistController();
            controller._callback = handleGetPricelists;
            controller.index(filterValues, 0, 0, "name", "asc", true);
        }
        else {
            setPricelists([]);
        }
    }
    const handleGetPricelists = (list, error, pagination, status) => {
        switch (status) {
            case 200:
                const catalogs = JSON.parse(localStorage.getItem("catalogs"))
                let listTmp = []
                let name
                let mainPricelist = null

                for (let i in list) {
                    if (catalogId === null)
                        name = "(" + catalogs[catalogs.findIndex(_ => _.id === list[i].catalog_id)].name + ") " + list[i].name;
                    else
                        name = list[i].name;

                    listTmp.push({
                        value: name,
                        id: list[i].id,
                        object: list[i]
                    });

                    if (mainPricelist === null && list[i].main === 1)
                        mainPricelist = list[i];
                }

                setPricelists(listTmp);

                if (mainPricelist !== null)
                    setPricelistId(mainPricelist.id);

                break;
            default: break;
        }
    }
    const getVats = () => {
        const controller = new VatRateController();
        controller._callback = handleGetVats;
        controller.index();
    }
    const handleGetVats = (list, error, status) => {
        switch (status) {
            case 200:
                let listTmp = [
                    {
                        name: "Toutes les TVA",
                        id: -1,
                        type: ""
                    }
                ];

                for (let i in list) {
                    listTmp.push({
                        name: list[i].name,
                        id: list[i].id,
                        object: list[i]
                    });
                }

                setVatRates(listTmp);
                break;
            default: break;
        }
    }
    const getTags = () => {
        const controller = new TagController();
        controller._callback = handleGetTags;
        controller.index("products");
    }
    const handleGetTags = (list, error, status) => {
        switch (status) {
            case 200:
                setTags(list);
                break;
            default: break;
        }
    }
    const updateFilters = () => {
        setFilters(prev => ({
            ...prev,
            catalogs: catalogs,
            categories: categories,
            vatRates: vatRates,
            tags: tags,
            variablePrice: [
                {
                    name: "Indifférent",
                    id: -1
                },
                {
                    name: "Oui",
                    id: 1
                },
                {
                    name: "Non",
                    id: 0
                }
            ]
        }));
    }
    const handleChangePriceable = val => {
        setPricelistId(parseInt(val));
    }
    const updatePageSelect = page => {
        setPageSelect(page);
    }
    const handleRefresh = (force = true) => {
        if (catalogId === null && filterValues.catalog_id === null)
            return;

        if (force) {
            if (pageSelect !== 1) {
                setPageSelect(1);
                return;
            }
        }

        getProducts(pageSelect, perPage, sortingName, sortingValue);
    }
    const handleUpdate = object => {
        let index = list.findIndex(item => item.id === object.id);
        if (index < 0) return;

        let listTmp = list.slice();
        let keys = Object.keys(listTmp[index]);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (object[key] !== undefined)
                listTmp[index][key] = object[key];
        }

        setList(listTmp);
    }
    const handleRemove = () => {
        handleRefresh();
    }
    const exportCatalog = () => {
        setExportForm(!exportForm);
    }
    const openFilters = () => {
        setShowFilters(true);
    }
    const closeFilters = () => {
        setShowFilters(false);
    }
    const validFilters = values => {
        closeFilters();
        setFilterValues(values);
    }

    useEffect(() => {
        document.title = "Back office - " + titleWindow;

        initStores();
        getCatalogs();
        getVats();
        getTags();
        updateModel();
        initFilters();
        initOptions();
    }, []);
    useEffect(() => {
        updateFilters();
    }, [catalogs, categories, pricelists, vatRates, stores, tags]);
    useEffect(() => {
        updateModel();
    }, [categories]);
    useEffect(() => {
        if (prevPageSelect === undefined || prevPerPage === undefined) return;

        if (pageSelect !== prevPageSelect || perPage !== prevPerPage)
            handleRefresh(false);
    }, [pageSelect, perPage]);
    useEffect(() => {
        if (prevCatalogId !== undefined || catalogId !== prevCatalogId) {
            getPricelists();
            getCategories();
        }
    }, [catalogId]);
    useEffect(() => {
        if (Object.keys(filterValues).length === 0) return;

        setCatalogId(filterValues.catalog_id);
        handleRefresh(true);
    }, [filterValues]);
    useEffect(() => {
        setContextValues(prev => ({
            ...prev,
            page: pageSelect,
            vatRates,
            typeFilters: "products",
            filters,
            filterValues,
            showFilters,
            openFilters,
            closeFilters,
            validFilters
        }));
    }, [showFilters, pageSelect, vatRates, filters, filterValues]);

    return(
        <ListingContext.Provider value={contextValues}>
            <FilterPopup />
            {
                exportForm
                && <ExportCatalog catalogId={ (filterValues.catalog_id !== undefined ? filterValues.catalog_id : 0) } cancel={exportCatalog} />
            }
            <Listing
                item={ item }
                itemClass={ itemClass }
                placeholderSearch={ placeholderSearch }
                titleNbItems={ titleNbItems }
                emptyList={ emptyList }
                model={ model }
                options={ options }
                secondaryOptions={ secondaryOptions }
                activeHistory={ activeHistory }
                pageSelect={ pageSelect }
                updatePageSelect={ updatePageSelect }
                list={ list }
                loading={ loading }
                pagination={ pagination }
                priceable={ pricelists.length > 0 ? pricelists : null }
                priceableValue={ pricelistId }
                storeableValue={ storeId }
                priceableChange={ handleChangePriceable }
                checkable={ false }
                openable={ true }
                setPerPage={ setPerPage }
                sortingName={ sortingName }
                sortingValue={ sortingValue }
                setSortingName={ setSortingName }
                setSortingValue={ setSortingValue } />
            <Switch>
                <Route exact path={ "/products/new" }>
                    <NewObject handleIndex={ handleRefresh } />
                </Route>
                <Route exact path={ "/catalogs/:idCatalog/products/:id/(information|pricelists|barcodes|stats)" }>
                    <ObjectSheet
                        objectType={ itemClass }
                        previousLink={ item }
                        textRemoveButton={ textRemoveButton }
                        handleUpdate={ handleUpdate }
                        handleRemove={ handleRemove } />
                </Route>
            </Switch>
        </ListingContext.Provider>
    )
}

export default Products;
